import { forEach } from 'lodash'

const makeSticky = (container) => {
    let clientHeight = 0;
    var containers = document.querySelectorAll('.sticky-header')

    forEach(containers, (stickyContainer) => {
        if(container.children[0] === stickyContainer){
            return false;
        }
        clientHeight += stickyContainer.clientHeight
    });

    if (container.getBoundingClientRect().top - clientHeight <= 0){
        container.style.height = container.clientHeight+'px';
        container.children[0].classList.add('sticky-header')
        container.children[0].style.top = clientHeight + 'px'
    } else {
        container.children[0].classList.remove('sticky-header')
    }
}

export default makeSticky

